import { render, staticRenderFns } from "./GLItem2.vue?vue&type=template&id=b1b3d6c0&"
import script from "./GLItem2.vue?vue&type=script&lang=js&"
export * from "./GLItem2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports